/**
 * Rollator Keuzehulp - ZHON design
 * Step wizard (intro → slider/choice questions → results) that scores real
 * collection products against metafield constraints en rendert een
 * persoonlijke top-N met upsell + e-mailcapture.
 */
class RollatorKeuzehulp extends HTMLElement {
  connectedCallback() {
    try {
      this.config = JSON.parse(this.querySelector('[data-rc-config]').textContent);
      this.products = JSON.parse(this.querySelector('[data-rc-products]').textContent);
    } catch (e) {
      console.error('[rollator-keuzehulp] invalid JSON', e);
      return;
    }
    this.questions = this.config.questions || [];
    this.labels = this.config.labels || {};
    this.budgetTolerance = this.config.budgetTolerance != null ? this.config.budgetTolerance : 25;

    this.els = {
      intro: this.querySelector('[data-rc-intro]'),
      quiz: this.querySelector('[data-rc-quiz]'),
      results: this.querySelector('[data-rc-results]'),
      progressWrap: this.querySelector('[data-rc-progress-wrap]'),
      progressBar: this.querySelector('[data-rc-progress-bar]'),
      kicker: this.querySelector('[data-rc-kicker]'),
      progressCount: this.querySelector('[data-rc-progress-count]'),
    };

    // state
    this.step = 0;
    this.answers = this.questions.map((q) => (q.type === 'slider' ? q.default : null));
    this.name = '';
    this.email = '';
    this.sent = false;
    // Welke schuifbalken de bezoeker zelf heeft versteld. Zolang dat niet zo is
    // volgt de stand het automatische bereik. Anders houdt de budgetbalk de
    // waarde vast die hij kreeg toen de restgroep nog veel groter was.
    this.sliderTouched = {};

    // Er wordt niets opgeslagen. Na een refresh begint de keuzehulp altijd
    // opnieuw vanaf het introscherm, zodat de volgende bezoeker een schone
    // start heeft. De enige uitzondering is de deeplink hieronder, die de
    // antwoorden uit de URL haalt.

    // Deeplink: ?rc=170,80,275,0,2 herstelt de antwoorden en springt naar het resultaat
    this.applyDeepLink();

    // slider drag bound handlers
    this._move = this._move.bind(this);
    this._up = this._up.bind(this);
    this.dragging = false;

    this.render();
  }

  /* ============ Icons ============ */
  ic(name, size = 24, sw = 2) {
    // Tabler Icons (outline, MIT). Inline zodat ze niet afhangen van de
    // webfont-link uit theme.liquid, die naar een externe CDN wijst.
    const paths = {
      ruler: ["M19.875 12c.621 0 1.125 .512 1.125 1.143v5.714c0 .631 -.504 1.143 -1.125 1.143h-15.875a1 1 0 0 1 -1 -1v-5.857c0 -.631 .504 -1.143 1.125 -1.143h15.75", "M9 12v2", "M6 12v3", "M12 12v3", "M18 12v3", "M15 12v2", "M3 3v4", "M3 5h18", "M21 3v4"], // ti-ruler-measure
      weight: ["M9 6a3 3 0 1 0 6 0a3 3 0 1 0 -6 0", "M6.835 9h10.33a1 1 0 0 1 .984 .821l1.637 9a1 1 0 0 1 -.984 1.179h-13.604a1 1 0 0 1 -.984 -1.179l1.637 -9a1 1 0 0 1 .984 -.821"], // ti-weight
      euro: ["M17.2 7a6 7 0 1 0 0 10", "M13 10h-8m0 4h8"], // ti-currency-euro
      pin: ["M9 11a3 3 0 1 0 6 0a3 3 0 0 0 -6 0", "M17.657 16.657l-4.243 4.243a2 2 0 0 1 -2.827 0l-4.244 -4.243a8 8 0 1 1 11.314 0"], // ti-map-pin
      star: ["M12 17.75l-6.172 3.245l1.179 -6.873l-5 -4.867l6.9 -1l3.086 -6.253l3.086 6.253l6.9 1l-5 4.867l1.179 6.873l-6.158 -3.245"], // ti-star
      home: ["M5 12l-2 0l9 -9l9 9l-2 0", "M5 12v7a2 2 0 0 0 2 2h10a2 2 0 0 0 2 -2v-7", "M9 21v-6a2 2 0 0 1 2 -2h2a2 2 0 0 1 2 2v6"], // ti-home
      sun: ["M8 12a4 4 0 1 0 8 0a4 4 0 1 0 -8 0", "M3 12h1m8 -9v1m8 8h1m-9 8v1m-6.4 -15.4l.7 .7m12.1 -.7l-.7 .7m0 11.4l.7 .7m-12.1 -.7l-.7 .7"], // ti-sun
      both: ["M21 17l-18 0", "M6 10l-3 -3l3 -3", "M3 7l18 0", "M18 20l3 -3l-3 -3"], // ti-arrows-left-right
      feather: ["M4 20l10 -10m0 -5v5h5m-9 -1v5h5m-9 -1v5h5m-5 -5l4 -4l4 -4", "M19 10c.638 -.636 1 -1.515 1 -2.486a3.515 3.515 0 0 0 -3.517 -3.514c-.97 0 -1.847 .367 -2.483 1m-3 13l4 -4l4 -4"], // ti-feather
      shield: ["M11.46 20.846a12 12 0 0 1 -7.96 -14.846a12 12 0 0 0 8.5 -3a12 12 0 0 0 8.5 3a12 12 0 0 1 -.09 7.06", "M15 19l2 2l4 -4"], // ti-shield-check
      sofa: ["M4 11a2 2 0 0 1 2 2v1h12v-1a2 2 0 1 1 4 0v5a1 1 0 0 1 -1 1h-18a1 1 0 0 1 -1 -1v-5a2 2 0 0 1 2 -2", "M4 11v-3a3 3 0 0 1 3 -3h10a3 3 0 0 1 3 3v3", "M12 5v9"], // ti-sofa
      minus: ["M5 12l14 0"], // ti-minus
      plus: ["M12 5l0 14", "M5 12l14 0"], // ti-plus
      arrow: ["M5 12l14 0", "M13 18l6 -6", "M13 6l6 6"], // ti-arrow-right
      back: ["M5 12l14 0", "M5 12l6 6", "M5 12l6 -6"], // ti-arrow-left
      check: ["M5 12l5 5l10 -10"], // ti-check
      mail: ["M3 7a2 2 0 0 1 2 -2h14a2 2 0 0 1 2 2v10a2 2 0 0 1 -2 2h-14a2 2 0 0 1 -2 -2v-10", "M3 7l9 6l9 -6"], // ti-mail
      gift: ["M3 9a1 1 0 0 1 1 -1h16a1 1 0 0 1 1 1v2a1 1 0 0 1 -1 1h-16a1 1 0 0 1 -1 -1l0 -2", "M12 8l0 13", "M19 12v7a2 2 0 0 1 -2 2h-10a2 2 0 0 1 -2 -2v-7", "M7.5 8a2.5 2.5 0 0 1 0 -5a4.8 8 0 0 1 4.5 5a4.8 8 0 0 1 4.5 -5a2.5 2.5 0 0 1 0 5"], // ti-gift
      bolt: ["M13 3l0 7l6 0l-8 11l0 -7l-6 0l8 -11"], // ti-bolt
      clock: ["M3 12a9 9 0 1 0 18 0a9 9 0 0 0 -18 0", "M12 7v5l3 3"], // ti-clock
      edit: ["M4 20h4l10.5 -10.5a2.828 2.828 0 1 0 -4 -4l-10.5 10.5v4", "M13.5 6.5l4 4"], // ti-pencil
      rollator: ["M12 4a1 1 0 1 0 2 0a1 1 0 1 0 -2 0", "M7 21l3 -4", "M16 21l-2 -4l-3 -3l1 -6", "M6 12l2 -3l4 -1l3 3l3 1"], // ti-walk
      wheelchair: ["M3 16a5 5 0 1 0 10 0a5 5 0 1 0 -10 0", "M17 19a2 2 0 1 0 4 0a2 2 0 1 0 -4 0", "M19 17a3 3 0 0 0 -3 -3h-3.4", "M3 3h1a2 2 0 0 1 2 2v6", "M6 8h11", "M15 8v6"], // ti-wheelchair
      wave: ["M21 12h-2c-.894 0 -1.662 -.857 -1.761 -2c-.296 -3.45 -.749 -6 -2.749 -6s-2.5 3.582 -2.5 8s-.5 8 -2.5 8s-2.452 -2.547 -2.749 -6c-.1 -1.147 -.867 -2 -1.763 -2h-2"], // ti-wave-sine
      expand: ["M16 4l4 0l0 4", "M14 10l6 -6", "M8 20l-4 0l0 -4", "M4 20l6 -6", "M16 20l4 0l0 -4", "M14 14l6 6", "M8 4l-4 0l0 4", "M4 4l6 6"], // ti-arrows-maximize
      arm: ["M8 11v-3.5a1.5 1.5 0 0 1 3 0v2.5", "M11 9.5v-3a1.5 1.5 0 0 1 3 0v3.5", "M14 7.5a1.5 1.5 0 0 1 3 0v2.5", "M17 9.5a1.5 1.5 0 0 1 3 0v4.5a6 6 0 0 1 -6 6h-2h.208a6 6 0 0 1 -5.012 -2.7l-.196 -.3c-.312 -.479 -1.407 -2.388 -3.286 -5.728a1.5 1.5 0 0 1 .536 -2.022a1.867 1.867 0 0 1 2.28 .28l1.47 1.47"], // ti-hand-grab
      alert: ["M12 9v4", "M10.363 3.591l-8.106 13.534a1.914 1.914 0 0 0 1.636 2.871h16.214a1.914 1.914 0 0 0 1.636 -2.87l-8.106 -13.536a1.914 1.914 0 0 0 -3.274 0", "M12 16h.01"], // ti-alert-triangle
    };
    if (name === 'dotcheck') name = 'check';
    const d = (paths[name] || []).map((p) => `<path d="${p}"></path>`).join('');
    return `<svg width="${size}" height="${size}" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="${sw}" stroke-linecap="round" stroke-linejoin="round" style="flex:none;width:${size}px;height:${size}px;display:block">${d}</svg>`;
  }

  /* ============ Utils ============ */
  esc(s) {
    return String(s == null ? '' : s).replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;').replace(/"/g, '&quot;');
  }
  num(raw) {
    if (raw === null || raw === undefined) return null;
    const m = String(raw).replace(',', '.').match(/-?\d+(\.\d+)?/);
    return m ? parseFloat(m[0]) : null;
  }
  fmtSlider(q, v) {
    return (q.prefix || '') + v + (q.suffix || '');
  }
  isPriceKey(key) { return key === 'price' || (key && key.endsWith('.price')); }

  scrollTop() {
    // Naar de bovenkant van de pagina. Eén scroll-aanroep zodat de globale
    // smooth scroll-behavior (theme.css) niet meteen wordt afgekapt door een
    // directe scrollTop-toewijzing.
    window.scrollTo(0, 0);
  }

  /* ============ Deeplink ============ */
  encodeAnswers() {
    // sliders → getalwaarde, keuzes → optie-index; null → leeg
    return this.answers.map((a) => (a == null ? '' : a)).join(',');
  }
  resultUrl() {
    const base = window.location.origin + window.location.pathname;
    return base + '?rc=' + encodeURIComponent(this.encodeAnswers());
  }
  applyDeepLink() {
    try {
      const rc = new URLSearchParams(window.location.search).get('rc');
      if (!rc) return false;
      const parts = rc.split(',');
      if (parts.length !== this.questions.length) return false;
      const restored = this.questions.map((q, i) => {
        const t = parts[i];
        if (t === '' || t == null) return q.type === 'slider' ? q.default : null;
        const n = parseInt(t, 10);
        if (isNaN(n)) return q.type === 'slider' ? q.default : null;
        if (q.type === 'slider') return n; // normaliseSliders klemt straks in het geldende bereik
        return (n >= 0 && n < q.options.length) ? n : null;
      });
      this.answers = restored;
      // Een deeplink draagt echte antwoorden, ook voor de balken. Die moeten
      // dus blijven staan en niet terugvallen op het automatische bereik.
      this.questions.forEach((q, i) => { if (q.type === 'slider' && parts[i] !== '') this.sliderTouched[i] = true; });
      this.step = this.questions.length + 1; // direct naar resultaat
      return true;
    } catch (e) { return false; }
  }
  clearDeepLink() {
    // Na 'opnieuw beginnen' mag een ?rc= uit de URL geen antwoorden meer
    // terugzetten bij een refresh.
    try {
      const url = new URL(window.location.href);
      if (!url.searchParams.has('rc')) return;
      url.searchParams.delete('rc');
      window.history.replaceState({}, '', url.pathname + url.search + url.hash);
    } catch (e) { /* noop */ }
  }

  restart() {
    this.answers = this.questions.map((q) => (q.type === 'slider' ? q.default : null));
    this.name = '';
    this.email = '';
    this.sent = false;
    // Welke schuifbalken de bezoeker zelf heeft versteld. Zolang dat niet zo is
    // volgt de stand het automatische bereik. Anders houdt de budgetbalk de
    // waarde vast die hij kreeg toen de restgroep nog veel groter was.
    this.sliderTouched = {};
    this.clearDeepLink();
    this.go(0, true); // opnieuw beginnen → terug naar de top
  }

  /* ============ Flow ============ */
  go(step, scroll = false) {
    // Standaard niet scrollen (bv. tussen vragen door). Alleen de aanroeper
    // die dat wil — sprong naar resultaten, wijzig antwoorden, opnieuw
    // beginnen — geeft scroll=true mee.
    this.step = step;
    this.render();
    if (scroll) this.scrollTop();
  }
  isQuestion() { return this.step >= 1 && this.step <= this.questions.length; }
  currentQ() { return this.isQuestion() ? this.questions[this.step - 1] : null; }

  /* ============ Voorwaardelijke vragen ============ */
  isVisible(i) {
    const q = this.questions[i];
    if (!q) return false;
    const src = (q.dependsQuestion || 0) - 1;
    if (this.tooFewLeft(i)) return false;
    // Alleen een eerdere vraag telt. Wijst de instelling vooruit of naar
    // zichzelf, dan stellen we de vraag gewoon, anders zou hij nooit meer
    // verschijnen.
    if (src < 0 || src >= i) return true;
    if (!this.isVisible(src)) return false;
    const ans = this.answers[src];
    if (ans == null) return false;
    const allowed = this.dependsOptions(q);
    if (!allowed.length) return true;
    // in de theme editor tellen antwoorden vanaf 1
    return allowed.indexOf(ans + 1) !== -1;
  }
  tooFewLeft(i) {
    // Een vraag die filtert over een handvol producten verandert niets meer.
    const cap = this.questions[i].skipIfMax || 0;
    return cap > 0 && this.poolAt(i).length <= cap;
  }
  dependsOptions(q) {
    if (!q._dependsOn) {
      q._dependsOn = String(q.dependsOptions || '')
        .split(',')
        .map((t) => parseInt(t, 10))
        .filter((n) => !isNaN(n));
    }
    return q._dependsOn;
  }
  visibleIndexes() {
    return this.questions.map((q, i) => i).filter((i) => this.isVisible(i));
  }
  effectiveAnswer(i) {
    if (this.isVisible(i)) return this.answers[i];
    // Een overgeslagen vraag mag een vast terugvalantwoord houden, zodat een
    // niet-gestelde vraag niet stilzwijgend alle eisen laat vallen.
    const q = this.questions[i];
    if (q.type !== 'slider' && q.skipAnswer) return q.skipAnswer - 1;
    return null;
  }
  seekVisible(from, dir) {
    let s = from + dir;
    while (s >= 1 && s <= this.questions.length && !this.isVisible(s - 1)) s += dir;
    return s;
  }

  canNext() {
    const q = this.currentQ();
    if (!q) return false;
    if (q.type === 'choice') return this.answers[this.step - 1] != null;
    return true; // sliders always have a value
  }
  onNext() {
    if (!this.canNext()) return;
    const target = Math.min(this.questions.length + 1, this.seekVisible(this.step, 1));
    // Alleen bij de sprong naar de resultatenpagina naar boven scrollen.
    this.go(target, target === this.questions.length + 1);
  }
  onPrev() {
    this.go(Math.max(0, this.seekVisible(this.step, -1)));
  }

  render() {
    this.normaliseSliders();
    const resultsStep = this.questions.length + 1;
    // Een eerder antwoord kan de huidige vraag onzichtbaar hebben gemaakt.
    if (this.isQuestion() && !this.isVisible(this.step - 1)) {
      this.step = Math.min(resultsStep, this.seekVisible(this.step, 1));
    }
    const showProgress = this.isQuestion();
    if (this.els.progressWrap) this.els.progressWrap.hidden = !showProgress;

    this.els.intro.hidden = this.step !== 0;
    this.els.quiz.hidden = !this.isQuestion();
    this.els.results.hidden = this.step !== resultsStep;

    if (this.step === 0) this.renderIntro();
    else if (this.isQuestion()) this.renderQuestion();
    else if (this.step === resultsStep) this.renderResults();

    if (showProgress) this.updateProgress();
  }

  updateProgress() {
    const vis = this.visibleIndexes();
    const idx = vis.indexOf(this.step - 1) + 1;
    const total = vis.length;
    if (this.els.progressBar) this.els.progressBar.style.width = (idx / total) * 100 + '%';
    if (this.els.kicker) {
      this.els.kicker.textContent = (this.labels.step || 'Vraag %1 van %2').replace('%1', idx).replace('%2', total);
    }
    if (this.els.progressCount) this.els.progressCount.textContent = idx + ' / ' + total;
  }

  /* ============ Intro ============ */
  renderIntro() {
    const c = this.config.intro || {};
    const hero = c.image
      ? `<img class="rc__hero" src="${c.image}" alt="${this.esc(c.title)}" loading="lazy">`
      : `<div class="rc__hero rc__hero--placeholder">${this.ic('rollator', 96, 1.5)}</div>`;
    const pills = (c.pills || []).map((p) =>
      `<div class="rc__pill">${this.ic(p.icon || 'check', 18)} ${this.esc(p.label)}</div>`).join('');

    this.els.intro.innerHTML = `
      <div class="rc__intro rc__animate">
        <div class="rc__intro-card">
          ${hero}
          <div class="rc__intro-body">
            <h1 class="rc__intro-title">${this.esc(c.title)}</h1>
            ${c.text ? `<div class="rc__intro-text rte">${c.text}</div>` : ''}
            ${pills ? `<div class="rc__pills">${pills}</div>` : ''}
            <button type="button" class="rc__btn rc__btn--lg" data-act="start">${this.esc(c.start)} ${this.ic('arrow', 20)}</button>
            ${c.trust ? `<p class="rc__trust">${this.esc(c.trust)}</p>` : ''}
          </div>
        </div>
      </div>`;
    this.els.intro.querySelector('[data-act="start"]').addEventListener('click', () => this.go(1));
  }

  /* ============ Question ============ */
  renderQuestion() {
    const q = this.currentQ();
    const i = this.step - 1;
    const body = q.type === 'slider' ? this.sliderHtml(q, i) : this.choiceHtml(q, i);
    const disabled = this.canNext() ? '' : 'disabled';

    this.els.quiz.innerHTML = `
      <div class="rc__q rc__animate">
        <div class="rc__q-head">
          <h2 class="rc__q-title">${this.esc(q.title)}</h2>
          ${q.subtitle ? `<p class="rc__q-sub">${this.esc(q.subtitle)}</p>` : ''}
        </div>
        ${body}
        <div class="rc__nav">
          <button type="button" class="rc__btn-text" data-act="prev">${this.ic('back', 20)} ${this.esc(this.labels.back || 'Vorige')}</button>
          <button type="button" class="rc__next" data-act="next" ${disabled}>${this.esc(this.nextLabel())} ${this.ic('arrow', 20)}</button>
        </div>
      </div>`;

    this.els.quiz.querySelector('[data-act="prev"]').addEventListener('click', () => this.onPrev());
    this.els.quiz.querySelector('[data-act="next"]').addEventListener('click', () => this.onNext());

    if (q.type === 'slider') this.bindSlider(q, i);
    else this.bindChoice(q, i);
  }

  nextLabel() {
    // Een antwoord kan de laatste vraag verschuiven, dus dit hangt af van wat
    // er ná deze vraag nog zichtbaar is.
    const isLast = this.seekVisible(this.step, 1) > this.questions.length;
    return isLast ? (this.labels.nextLast || 'Bekijk mijn matches') : (this.labels.next || 'Volgende');
  }
  refreshNav() {
    const next = this.els.quiz.querySelector('[data-act="next"]');
    if (!next) return;
    next.disabled = !this.canNext();
    next.innerHTML = this.esc(this.nextLabel()) + ' ' + this.ic('arrow', 20);
  }

  sliderHtml(q, i) {
    const r = this.sliderRange(q, i);
    const v = this.answers[i];
    const pct = ((v - r.min) / (r.max - r.min)) * 100;
    return `
      <div class="rc__slider-card">
        <div class="rc__slider-value">
          <div class="rc__slider-num" data-rc-slider-num>${this.esc(this.fmtSlider(q, v))}</div>
        </div>
        <div class="rc__slider-row">
          <button type="button" class="rc__step-btn" data-act="minus" aria-label="Minder">${this.ic('minus', 24, 2.4)}</button>
          <div class="rc__track" tabindex="0" data-rc-track role="slider"
               aria-valuemin="${r.min}" aria-valuemax="${r.max}" aria-valuenow="${v}">
            <div class="rc__track-base no-empty"></div>
            <div class="rc__track-fill no-empty" data-rc-fill style="width:${pct}%"></div>
            <div class="rc__track-thumb no-empty" data-rc-thumb style="left:${pct}%"></div>
          </div>
          <button type="button" class="rc__step-btn" data-act="plus" aria-label="Meer">${this.ic('plus', 24, 2.4)}</button>
        </div>
        <div class="rc__slider-scale">
          <span>${this.esc(this.fmtSlider(q, r.min))}</span>
          <span>${this.esc(this.fmtSlider(q, r.max) + (r.max === q.max ? (q.maxSuffix || '') : ''))}</span>
        </div>
        <p class="rc__slider-hint">${this.esc(this.labels.sliderHint || '')}</p>
      </div>`;
  }

  bindSlider(q, i) {
    this.track = this.els.quiz.querySelector('[data-rc-track]');
    this.els.quiz.querySelector('[data-act="minus"]').addEventListener('click', () => this.stepBy(q, i, -1));
    this.els.quiz.querySelector('[data-act="plus"]').addEventListener('click', () => this.stepBy(q, i, 1));
    this.track.addEventListener('pointerdown', (e) => this.onTrackDown(e, q, i));
    this.track.addEventListener('keydown', (e) => {
      if (e.key === 'ArrowRight' || e.key === 'ArrowUp') { this.stepBy(q, i, 1); e.preventDefault(); }
      if (e.key === 'ArrowLeft' || e.key === 'ArrowDown') { this.stepBy(q, i, -1); e.preventDefault(); }
    });
  }
  setSlider(q, i, val) {
    const r = this.sliderRange(q, i);
    val = Math.max(r.min, Math.min(r.max, val));
    this.sliderTouched[i] = true;
    if (val === this.answers[i]) return;
    this.answers[i] = val;
    const pct = ((val - r.min) / (r.max - r.min)) * 100;
    const num = this.els.quiz.querySelector('[data-rc-slider-num]');
    const fill = this.els.quiz.querySelector('[data-rc-fill]');
    const thumb = this.els.quiz.querySelector('[data-rc-thumb]');
    if (num) num.textContent = this.fmtSlider(q, val);
    if (fill) fill.style.width = pct + '%';
    if (thumb) thumb.style.left = pct + '%';
    if (this.track) this.track.setAttribute('aria-valuenow', val);
  }
  stepBy(q, i, dir) { this.setSlider(q, i, this.answers[i] + dir * this.sliderRange(q, i).step); }
  applyFromEvent(e, q, i) {
    if (!this.track) return;
    const box = this.track.getBoundingClientRect();
    let p = (e.clientX - box.left) / box.width;
    p = Math.max(0, Math.min(1, p));
    const r = this.sliderRange(q, i);
    const raw = r.min + p * (r.max - r.min);
    const snapped = Math.round(raw / r.step) * r.step;
    this.setSlider(q, i, snapped);
  }
  onTrackDown(e, q, i) {
    this.dragging = true;
    this._dragCtx = { q, i };
    this.applyFromEvent(e, q, i);
    document.addEventListener('pointermove', this._move);
    document.addEventListener('pointerup', this._up);
    e.preventDefault();
  }
  _move(e) { if (this.dragging && this._dragCtx) this.applyFromEvent(e, this._dragCtx.q, this._dragCtx.i); }
  _up() { this.dragging = false; document.removeEventListener('pointermove', this._move); document.removeEventListener('pointerup', this._up); }
  disconnectedCallback() { this._up(); }

  choiceHtml(q, i) {
    const sel = this.answers[i];
    const opts = q.options.map((o, oi) => {
      const isSel = sel === oi ? ' is-selected' : '';
      const check = sel === oi ? this.ic('check', 16, 2.5) : '';
      return `
        <button type="button" class="rc__choice${isSel}" data-opt="${oi}">
          <div class="rc__choice-icon">${this.ic(o.icon || 'star', 26)}</div>
          <div class="rc__choice-body">
            <div class="rc__choice-label">${this.esc(o.label)}</div>
            ${o.desc ? `<div class="rc__choice-desc">${this.esc(o.desc)}</div>` : ''}
          </div>
          <div class="rc__choice-check no-empty">${check}</div>
        </button>`;
    }).join('');
    return `<div class="rc__choices">${opts}</div>`;
  }
  bindChoice(q, i) {
    const knoppen = this.els.quiz.querySelectorAll('[data-opt]');
    knoppen.forEach((btn) => {
      btn.addEventListener('click', () => {
        this.answers[i] = parseInt(btn.dataset.opt, 10);
        // Alleen de selectie bijwerken. De vraag opnieuw opbouwen zou de
        // binnenkomst-animatie bij elke klik opnieuw afspelen; die hoort
        // alleen bij het wisselen van stap.
        knoppen.forEach((b) => {
          const gekozen = b === btn;
          b.classList.toggle('is-selected', gekozen);
          const vink = b.querySelector('.rc__choice-check');
          if (vink) vink.innerHTML = gekozen ? this.ic('check', 16, 2.5) : '';
        });
        // Het antwoord kan bepalen welke vragen hierna nog komen, dus de
        // knoptekst en de voortgang kunnen veranderen.
        this.refreshNav();
        this.updateProgress();
      });
    });
  }

  /* ============ Scoring ============ */
  inCollection(q, product) {
    const ids = q.collectionIds || [];
    // geen collectie ingesteld of leeg: niet filteren, anders valt alles af
    if (!ids.length) return null;
    return ids.indexOf(product.id) !== -1;
  }
  otherCollectionIds(q, skipIndex) {
    // De ids van alle collecties bij de ándere antwoorden, voor de optie
    // 'geen van de andere' (bv. "nee, een gewone rollator"). Staan de speciale
    // uitvoeringen in een vervolgvraag, dan wijst 'excludeFromQuestion' daarheen.
    if (!q._otherIds) {
      const extern = [];
      const bron = this.questions[(q.excludeFromQuestion || 0) - 1];
      if (bron && bron !== q) {
        (bron.options || []).forEach((o) => {
          if (o.exclusive !== false) Array.prototype.push.apply(extern, o.collectionIds || []);
        });
      }
      q._otherIds = q.options.map((_, oi) => {
        const set = extern.slice();
        q.options.forEach((o2, oi2) => {
          // Een antwoord kan uit de uitsluiting worden gehouden: XL is geen
          // aparte soort rollator maar een extra eigenschap, dus een XL-model
          // mag ook als gewone rollator geadviseerd worden.
          if (oi2 !== oi && o2.exclusive !== false) {
            Array.prototype.push.apply(set, o2.collectionIds || []);
          }
        });
        return set;
      });
    }
    return q._otherIds[skipIndex] || [];
  }
  evalOptionCollection(q, oi, product) {
    const o = q.options[oi];
    if (!o || !o.mode || o.mode === 'any') return 'skip';
    if (o.mode === 'exclude_others') {
      const others = this.otherCollectionIds(q, oi);
      // niets om uit te sluiten → niet filteren
      if (!others.length) return 'skip';
      return others.indexOf(product.id) === -1 ? 'pass' : 'fail';
    }
    const ids = o.collectionIds || [];
    // lege of niet-ingestelde collectie → niet filteren, anders valt alles af
    if (!ids.length) return 'skip';
    return ids.indexOf(product.id) !== -1 ? 'pass' : 'fail';
  }
  evalChoice(raw, o) {
    const op = o.operator;
    if (op === 'any' || !op) return 'skip';
    // collectielidmaatschap: raw is dan een boolean, of null bij een lege collectie
    if (op === 'in' || op === 'not_in') {
      if (typeof raw !== 'boolean') return 'skip';
      return (op === 'in') === raw ? 'pass' : 'fail';
    }
    // numeric-ish unless contains/equals
    if (op === 'contains' || op === 'equals') {
      if (raw === null || raw === undefined || raw === '') return 'unknown';
      const hay = String(raw).toLowerCase();
      const needle = String(o.value || '').toLowerCase().trim();
      if (!needle) return 'pass';
      return op === 'equals' ? (hay.trim() === needle ? 'pass' : 'fail') : (hay.indexOf(needle) !== -1 ? 'pass' : 'fail');
    }
    const n = this.num(raw);
    if (n === null) return 'unknown';
    const v = this.num(o.value);
    if (v === null) return 'pass';
    switch (op) {
      case 'gte': return n >= v ? 'pass' : 'fail';
      case 'lte': return n <= v ? 'pass' : 'fail';
      case 'gt': return n > v ? 'pass' : 'fail';
      case 'lt': return n < v ? 'pass' : 'fail';
      case 'eq': return n === v ? 'pass' : 'fail';
      case 'between': {
        const v2 = this.num(o.value2);
        const lo = Math.min(v, v2 === null ? v : v2);
        const hi = Math.max(v, v2 === null ? v : v2);
        return n >= lo && n <= hi ? 'pass' : 'fail';
      }
      default: return 'skip';
    }
  }
  evalSlider(raw, q, answer, tol) {
    if (q.operator === 'none' || !q.operator) return 'skip';
    const n = this.num(raw);
    if (n === null) return 'unknown';
    const a = this.num(answer);
    if (a === null) return 'skip';
    tol = tol || 0;
    switch (q.operator) {
      case 'gte': return n >= a - tol ? 'pass' : 'fail';
      case 'lte': return n <= a + tol ? 'pass' : 'fail';
      case 'eq': return Math.abs(n - a) <= tol ? 'pass' : 'fail';
      default: return 'skip';
    }
  }

  evalQuestion(q, i, product) {
    const ans = this.effectiveAnswer(i);
    let raw = product.values[i];
    if (this.isPriceKey(q.key)) raw = product.price / 100;

    let res, tag = null, imp = q.importance;
    if (q.type === 'slider') {
      if (imp === 'display') return null;
      const isPrice = this.isPriceKey(q.key);
      const tol = isPrice ? this.budgetTolerance : 0;
      res = this.evalSlider(raw, q, ans, tol);
      tag = q.tag;
      // Een product dat alleen dankzij de speling meekomt krijgt de badge
      // 'Net erboven'. Dan mag de tag niet 'Binnen budget' beweren.
      if (isPrice && res === 'pass' && this.evalSlider(raw, q, ans, 0) !== 'pass') tag = null;
    } else {
      const o = q.options[ans];
      if (!o) return null;
      if (o.importance && o.importance !== 'inherit') imp = o.importance;
      if (imp === 'display') return null;
      if (q.source === 'option_collection') {
        res = this.evalOptionCollection(q, ans, product);
      } else {
        if (q.source === 'collection') raw = this.inCollection(q, product);
        res = this.evalChoice(raw, o);
      }
      tag = o.tag;
    }
    if (res === 'skip') return null;
    return { res, imp, tag, weight: q.weight || 1 };
  }

  score(product, skipIndex) {
    let hardFails = 0, hardUnknowns = 0, prefScore = 0, prefMax = 0;
    const tags = [], warnings = [];

    this.questions.forEach((q, i) => {
      // De upgrade-banner stapt bewust over één vraag heen: hij mag juist een
      // betere soort voorstellen dan die gekozen is.
      if (skipIndex != null && i === skipIndex) return;
      const r = this.evalQuestion(q, i, product);
      if (!r) return;
      if (r.imp === 'hard') {
        if (r.res === 'fail') { hardFails++; warnings.push(q.warnLabel || q.title); }
        else if (r.res === 'unknown') hardUnknowns++;
        else if (r.tag) tags.push(r.tag);
      } else {
        if (r.res === 'unknown') return;
        prefMax += r.weight;
        if (r.res === 'pass') { prefScore += r.weight; if (r.tag) tags.push(r.tag); }
      }
    });

    const matchPct = prefMax > 0 ? Math.round((prefScore / prefMax) * 100) : null;
    return { product, eligible: hardFails === 0, hardFails, hardUnknowns, matchPct, tags, warnings };
  }

  /* ============ Restgroep na de eerdere vragen ============ */
  poolAt(index) {
    // Producten die nog voldoen aan de harde eisen uit de vragen vóór deze.
    // De sleutel gebruikt alleen de eerdere antwoorden, zodat het slepen aan
    // de huidige schuifbalk de cache niet elke frame ongeldig maakt.
    const key = index + '|' + this.answers.slice(0, index).join(',');
    this._pools = this._pools || {};
    if (this._pools[key]) return this._pools[key];
    const pool = this.products.filter((p) => {
      for (let i = 0; i < index; i++) {
        const r = this.evalQuestion(this.questions[i], i, p);
        if (r && r.imp === 'hard' && r.res === 'fail') return false;
      }
      return true;
    });
    this._pools[key] = pool;
    return pool;
  }

  /* ============ Schuifbalk-bereik ============ */
  sliderRange(q, i) {
    const vast = { min: q.min, max: q.max, step: q.step, def: q.default };
    if (!q.autoRange || !this.isPriceKey(q.key)) return vast;
    const prijzen = this.poolAt(i).map((p) => p.price / 100);
    if (!prijzen.length) return vast;
    const lo = Math.min.apply(null, prijzen);
    const hi = Math.max.apply(null, prijzen);
    // Stapgrootte meeschalen met het bereik, anders wordt slepen ondoenlijk
    // bij een grote spreiding. De ingestelde stap is de ondergrens.
    const rond = [5, 10, 25, 50, 100, 250, 500, 1000];
    const span = hi - lo;
    let step = rond.filter((n) => n >= span / 30)[0] || 1000;
    step = Math.max(step, q.step || 1);
    // Naar boven afronden, zodat bij het minimum de goedkoopste er nog in past
    // en bij het maximum alles.
    const min = Math.ceil(lo / step) * step;
    const max = Math.max(min + step, Math.ceil(hi / step) * step);
    // De ingestelde startwaarde slaat nergens op zodra het bereik meebeweegt,
    // dus die volgt uit een stand. 'median' is het midden van de prijzen zelf
    // en niet van de as, dus ongevoelig voor één dure uitschieter.
    let start;
    if (q.autoDefault === 'min') start = min;
    else if (q.autoDefault === 'max') start = max;
    else if (q.autoDefault === 'median') {
      const gesorteerd = prijzen.slice().sort((a, b) => a - b);
      const m = Math.floor(gesorteerd.length / 2);
      start = gesorteerd.length % 2 ? gesorteerd[m] : (gesorteerd[m - 1] + gesorteerd[m]) / 2;
    } else start = (min + max) / 2;
    return { min, max, step, def: this.snapTo(start, { min, max, step }) };
  }
  snapTo(v, r) {
    if (v == null || isNaN(v)) return r.min;
    const n = Math.max(r.min, Math.min(r.max, v));
    return Math.max(r.min, Math.min(r.max, r.min + Math.round((n - r.min) / r.step) * r.step));
  }
  normaliseSliders() {
    // Verandert een eerder antwoord de restgroep, dan verschuift het bereik
    // van de budgetbalk mee. Het opgeslagen antwoord moet daar in blijven
    // vallen, anders wijkt wat je ziet af van waarop gefilterd wordt.
    this.questions.forEach((q, i) => {
      if (q.type !== 'slider') return;
      const r = this.sliderRange(q, i);
      const a = this.sliderTouched[i] ? this.answers[i] : null;
      this.answers[i] = this.snapTo(a == null ? r.def : a, r);
    });
  }

  rank() {
    this.normaliseSliders();
    const budget = this.budgetAnswer();
    const tol = this.budgetTolerance;
    const scored = this.products.map((p) => {
      const s = this.score(p);
      s.within = budget == null || (p.price / 100) <= budget + tol;
      s.over = budget == null ? 0 : Math.max(0, (p.price / 100) - budget);
      return s;
    });
    const sf = (a, b) => {
      if (a.hardFails !== b.hardFails) return a.hardFails - b.hardFails;
      // bewezen geschikt gaat vóór onbekend: veiligheid weegt zwaarder dan budget
      if (a.hardUnknowns !== b.hardUnknowns) return a.hardUnknowns - b.hardUnknowns;
      // binnen budget gaat altijd vóór boven budget
      if (a.within !== b.within) return a.within ? -1 : 1;
      if (!a.within && !b.within) {
        // beide boven budget → dichtst bij budget (goedkoopst) eerst
        if (a.over !== b.over) return a.over - b.over;
        return a.product.price - b.product.price;
      }
      // beide binnen budget (of geen budgetvraag) → kwaliteit + voorkeur
      const pa = a.matchPct == null ? 0 : a.matchPct;
      const pb = b.matchPct == null ? 0 : b.matchPct;
      if (pa !== pb) return pb - pa;
      // Duurste eerst: wie een budget opgeeft, geeft dat niet voor niks op.
      // Binnen budget adviseren we de bovenkant, niet de goedkoopste plank.
      // Blijft het gelijkspel, dan wint wie hoger in de collectie staat: de
      // sortering is stabiel, dus die volgorde is de handmatige voorrang.
      return b.product.price - a.product.price;
    };
    const eligible = scored.filter((s) => s.eligible).sort(sf);
    // Zijn er passende rollators, dan tonen we er alleen die, ook al zijn het
    // er minder dan N. Aanvullen met producten die een harde eis niet halen
    // levert een advies op dat er goed uitziet maar niet klopt.
    const rest = eligible.length ? [] : scored.filter((s) => !s.eligible).sort(sf);
    // Spreiden mag nooit ten koste gaan van het budget: liever twee kaarten met
    // bijna dezelfde prijs die passen, dan een derde die er net boven zit. Dus
    // eerst de rollators binnen budget vullen, pas daarna de rest.
    const aantal = this.config.resultsCount || 3;
    const geordend = eligible.concat(rest);
    const winners = this.spreidPrijzen(geordend.filter((s) => s.within), aantal);
    if (winners.length < aantal) {
      const tekort = aantal - winners.length;
      Array.prototype.push.apply(winners, this.spreidPrijzen(geordend.filter((s) => !s.within), tekort));
    }
    // De best gerangschikte houdt de accentrand, ook al staat hij straks
    // niet meer vooraan.
    winners.forEach((w, i) => { w.isTop = i === 0; });
    // Weergave wel van goedkoop naar duur, dat leest prettiger dan andersom.
    return winners.slice().sort((a, b) => a.product.price - b.product.price);
  }

  /**
   * Drie kaarten van dezelfde prijs geven geen keuze. Loop de ranglijst van
   * boven af door en sla een rollator over die te dicht bij een al gekozen
   * prijs zit. Blijven er zo te weinig over, dan vullen we alsnog aan, want
   * één kaart tonen is slechter dan twee met dezelfde prijs.
   */
  spreidPrijzen(lijst, aantal) {
    const gap = (this.config.minPriceGap != null ? this.config.minPriceGap : 5) * 100;
    const gekozen = [], overgeslagen = [];
    lijst.forEach((s) => {
      if (gekozen.length >= aantal) return;
      const dichtbij = gekozen.some((w) => Math.abs(w.product.price - s.product.price) <= gap);
      if (dichtbij) overgeslagen.push(s);
      else gekozen.push(s);
    });
    for (let i = 0; i < overgeslagen.length && gekozen.length < aantal; i++) gekozen.push(overgeslagen[i]);
    return gekozen;
  }

  budgetAnswer() {
    const idx = this.questions.findIndex((q) => q.type === 'slider' && this.isPriceKey(q.key));
    if (idx === -1 || !this.isVisible(idx)) return null;
    return this.num(this.answers[idx]);
  }

  /* ============ Results ============ */
  money(cents) {
    const v = cents / 100;
    return '€ ' + (v % 1 === 0 ? v.toFixed(0) : v.toFixed(2).replace('.', ','));
  }

  renderResults() {
    const r = this.config.results || {};
    const winners = this.rank();
    this.lastWinners = winners;
    const budget = this.budgetAnswer();

    const chips = this.summaryChips();
    const cards = winners.map((w, idx) => this.cardHtml(w, idx, r, budget)).join('');
    // De titel noemt het aantal, en er zijn er niet altijd drie.
    const title = winners.length === 1 && r.titleOne
      ? r.titleOne
      : (r.title || '').replace('%s', winners.length);

    this.els.results.innerHTML = `
      <div class="rc__results rc__animate">
        <div class="rc__results-head">
          ${r.badge ? `<div class="rc__results-badge">${this.ic('check', 16, 2.4)} ${this.esc(r.badge)}</div>` : ''}
          <h2 class="rc__results-title">${this.esc(title)}</h2>
          <p class="rc__results-intro">${this.esc(this.resultIntro())}</p>
        </div>
        <div class="rc__chips">${chips}</div>
        <div class="rc__results-actions">
          <button type="button" class="rc__action rc__action--primary" data-act="edit">${this.ic('edit', 17)} ${this.esc(r.edit || 'Wijzig antwoorden')}</button>
          <button type="button" class="rc__action rc__action--ghost" data-act="restart">${this.ic('back', 17)} ${this.esc((this.config.email && this.config.email.restart) || 'Opnieuw beginnen')}</button>
        </div>
        <div class="rc__grid${winners.length < (this.config.resultsCount || 3) ? ' rc__grid--few' : ''}">${cards}</div>
        ${this.upsellHtml(winners)}
        ${this.emailHtml()}
      </div>`;

    const edit = this.els.results.querySelector('[data-act="edit"]');
    if (edit) edit.addEventListener('click', () => this.go(1, true)); // wijzig antwoorden → terug naar de top
    const restart = this.els.results.querySelector('.rc__results-actions [data-act="restart"]');
    if (restart) restart.addEventListener('click', () => this.restart());
    this.bindEmail();
  }

  resultIntro() {
    // korte samenvatting van de gegeven antwoorden
    const parts = [];
    this.questions.forEach((q, i) => {
      if (!this.isVisible(i)) return;
      if (q.type === 'slider') parts.push(this.fmtSlider(q, this.answers[i]));
      else if (q.options[this.answers[i]]) parts.push(q.options[this.answers[i]].label);
    });
    return parts.length ? 'Op basis van ' + parts.join(', ') + '.' : '';
  }

  summaryChips() {
    return this.questions.map((q, i) => {
      let label;
      if (!this.isVisible(i)) return '';
      if (q.type === 'slider') label = this.fmtSlider(q, this.answers[i]);
      else if (q.options[this.answers[i]]) label = q.options[this.answers[i]].label;
      else return '';
      return `<span class="rc__chip">${this.ic(q.icon || 'check', 15)} ${this.esc(label)}</span>`;
    }).join('');
  }

  cardHtml(w, idx, r, budget) {
    const p = w.product;
    // De kaarten staan op prijs, de accentrand hoort bij de beste match.
    const isTop = w.isTop === true;
    const spec = p.spec || {};
    const specs = [];
    if (spec.maxweight) specs.push(this.specRow(r.specMaxweight, spec.maxweight));
    if (spec.weight) specs.push(this.specRow(r.specWeight, spec.weight));
    const warranty = spec.warranty || r.warrantyDefault;
    if (warranty) specs.push(this.specRow(r.specWarranty, warranty));

    const reason = w.tags.length
      ? `<div class="rc__pcard-reason"><strong>${this.esc(r.reasonLabel || '')}</strong> ${this.esc(w.tags.join(' · '))}</div>`
      : '';

    // Er wordt altijd tot N aangevuld. Voldoet een aanvulling niet aan een
    // harde eis, dan moet dat op de kaart staan en niet stilzwijgend meeliften.
    const warn = w.warnings.length
      ? `<div class="rc__pcard-warn">${this.ic('alert', 16, 2)}<span>${this.esc(w.warnings.join(' · '))}</span></div>`
      : '';

    let badge = '';
    if (budget != null) {
      const over = (p.price / 100) - budget;
      if (over <= 0) badge = `<span class="rc__budge rc__budge--in">Binnen budget</span>`;
      else if (over <= this.budgetTolerance) badge = `<span class="rc__budge rc__budge--over">Net erboven</span>`;
      else badge = `<span class="rc__budge rc__budge--far">Boven budget</span>`;
    }

    const rating = (this.config.results.showRating && spec.rating)
      ? `<span class="rc__pcard-rating"><span class="rc__star">★</span> ${this.esc(spec.rating)}</span>` : '';

    const media = p.image
      ? `<img src="${p.image}" alt="${this.esc(p.title)}" loading="lazy">`
      : `<div class="rc__pcard-media--placeholder">${this.ic('rollator', 90, 1.5)}</div>`;

    return `
      <div class="rc__pcard${isTop ? ' is-top' : ''}">
        <div class="rc__pcard-media">${media}</div>
        <div class="rc__pcard-body">
          <div class="rc__pcard-meta">
            ${p.vendor ? `<span class="rc__pcard-brand">${this.esc(p.vendor)}</span>` : ''}
            ${rating}
          </div>
          <div class="rc__pcard-name">${this.esc(p.title)}</div>
          ${specs.length ? `<div class="rc__pcard-specs">${specs.join('')}</div>` : ''}
          ${warn}
          <div class="rc__pcard-foot">
            ${reason}
            <div class="rc__pcard-price-row">
              <span class="rc__pcard-price">${this.money(p.price)}</span>
              ${badge}
            </div>
            <a class="rc__pcard-cta" href="${p.url}" target="_blank" rel="noopener">${this.esc(this.labels.view || 'Bekijk rollator')} ${this.ic('arrow', 18)}</a>
          </div>
        </div>
      </div>`;
  }
  specRow(tpl, val) {
    const txt = (tpl || '%s').replace('%s', `<strong>${this.esc(val)}</strong>`);
    return `<div class="rc__pcard-spec">${this.ic('dotcheck', 17, 2.4)} <span>${txt}</span></div>`;
  }

  /**
   * De trappen boven het gegeven antwoord, voor een vraag waarvan de antwoorden
   * oplopen in klasse. Bij 'Wilt u een lichte rollator?' is dat maakt niet uit,
   * lichtgewicht, carbon. De eerstvolgende trap komt eerst, zodat de meerprijs
   * zo klein mogelijk blijft.
   */
  upgradeLadderQuestion() {
    for (let qi = 0; qi < this.questions.length; qi++) {
      const q = this.questions[qi];
      if (q.upgradeLadder && this.isVisible(qi) && this.effectiveAnswer(qi) != null) return q;
    }
    return null;
  }

  upgradeSteps() {
    const uit = [];
    this.questions.forEach((q, qi) => {
      if (!q.upgradeLadder || !this.isVisible(qi)) return;
      const ans = this.effectiveAnswer(qi);
      if (ans == null) return;
      (q.options || []).forEach((o, oi) => {
        // Alleen omhoog. Een goedkopere klasse voorstellen is geen upgrade.
        if (oi <= ans) return;
        // Zonder eigen collectie is er niets aan te wijzen.
        if (!o.collectionIds || !o.collectionIds.length) return;
        uit.push({ qi: qi, oi: oi, option: o });
      });
    });
    return uit;
  }

  /**
   * Kiest een duurdere rollator dan alles wat al getoond wordt. Er is geen
   * ondergrens: is het verschil klein, dan is dat juist een goed aanbod.
   * Eerst wordt geprobeerd een klasse hoger te gaan (bv. van lichtgewicht naar
   * carbon). Lukt dat niet, dan een duurder model binnen dezelfde keuze.
   */
  pickUpsell(winners) {
    const eligible = winners.filter((w) => w.eligible);
    const shownList = eligible.length ? eligible : winners;
    if (!shownList.length) return null;
    // Valt het advies zelf al buiten het budget, dan is een duurder voorstel
    // niet slim maar vervelend. Dan houden we de banner weg.
    const budget = this.budgetAnswer();
    const duurste = Math.max.apply(null, shownList.map((w) => w.product.price));
    if (budget != null && duurste / 100 > budget) return null;
    const stappen = this.upgradeSteps();
    for (let i = 0; i < stappen.length; i++) {
      const sel = this.pickUpsellFor(winners, shownList, stappen[i]);
      if (sel) return sel;
    }
    return this.pickUpsellFor(winners, shownList, null);
  }

  pickUpsellFor(winners, shownList, stap) {
    const u = this.config.upsell || {};
    const basePrice = Math.max.apply(null, shownList.map((w) => w.product.price));
    const shown = winners.map((w) => w.product.id);

    // Bovengrens: een voorstel van het dubbele van het budget verkoopt niets.
    const maxPct = u.maxExtra != null ? u.maxExtra : 120;
    let plafond = basePrice * (1 + maxPct / 100);
    const budget = this.budgetAnswer();
    if (budget != null) {
      const bp = u.maxBudget != null ? u.maxBudget : 175;
      plafond = Math.min(plafond, budget * 100 * (bp / 100));
    }

    // Gaat de vraag over gewicht, dan mag een stap omhoog nooit een zwaardere
    // rollator zijn. Bij een klasse hoger noemen we dat ook in de tekst, dus
    // daar moet hij lichter zijn dan alles op het scherm. Bij een duurder model
    // binnen dezelfde keuze volstaat het dat hij niet zwaarder is dan waar we
    // de meerprijs vanaf rekenen.
    const ladder = this.upgradeLadderQuestion();
    let maxGewicht = null;
    if (ladder && ladder.upgradeRequire === 'lighter') {
      if (stap) {
        const g = shownList.map((w) => this.num(w.product.spec && w.product.spec.weight)).filter((n) => n != null);
        if (!g.length) return null;
        maxGewicht = Math.min.apply(null, g);
      } else {
        const basis = shownList.filter((w) => w.product.price === basePrice)[0];
        maxGewicht = this.num(basis && basis.product.spec && basis.product.spec.weight);
        if (maxGewicht == null) return null;
      }
    }

    const pool = this.products
      .filter((p) => shown.indexOf(p.id) === -1)
      .filter((p) => p.price > basePrice && p.price <= plafond)
      .filter((p) => !stap || this.evalOptionCollection(this.questions[stap.qi], stap.oi, p) === 'pass')
      .filter((p) => {
        if (maxGewicht == null) return true;
        const g = this.num(p.spec && p.spec.weight);
        return g != null && g < maxGewicht;
      })
      // alleen rollators waarvan we zeker weten dat ze voldoen, geen onbekende specs
      .map((p) => this.score(p, stap ? stap.qi : null))
      .filter((s) => s.eligible && s.hardUnknowns === 0);
    if (!pool.length) return null;

    // De goedkoopste daarboven, dan blijft 'voor zoveel meer' het kleinst.
    pool.sort((a, b) => a.product.price - b.product.price);
    return { item: pool[0], extra: pool[0].product.price - basePrice, base: basePrice, step: stap };
  }

  upsellHtml(winners) {
    const u = this.config.upsell || {};
    if (!u.enable) return '';
    const sel = this.pickUpsell(winners || []);
    if (!sel) return '';

    const p = sel.item.product;
    const r = this.config.results || {};
    const extra = this.money(sel.extra);
    // Een klasse hoger krijgt zijn eigen zin, die mag de soort noemen.
    const soort = sel.step ? (sel.step.option.upgradeName || sel.step.option.label || '') : '';
    const tplT = soort && u.titleUpgrade ? u.titleUpgrade : u.title;
    const tplX = soort && u.textUpgrade ? u.textUpgrade : u.text;
    const title = tplT ? this.esc(tplT).replace('%s', this.esc(extra)).replace('%t', this.esc(soort)) : '';
    // De meerprijs geldt ten opzichte van de duurste kaart. Die prijs staat er
    // bij, anders lijkt het verschil kleiner dan het voor de klant is.
    const diff = (u.diffLabel || '%s meer dan de duurste uit uw advies van %b')
      .replace('%s', extra).replace('%b', this.money(sel.base));

    const spec = p.spec || {};
    const chips = [];
    if (spec.maxweight) chips.push(this.upsellSpec(r.specMaxweight, spec.maxweight));
    if (spec.weight) chips.push(this.upsellSpec(r.specWeight, spec.weight));
    const warranty = spec.warranty || r.warrantyDefault;
    if (warranty) chips.push(this.upsellSpec(r.specWarranty, warranty));

    const media = p.image
      ? `<img src="${p.image}" alt="${this.esc(p.title)}" loading="lazy">`
      : this.ic('rollator', 60, 1.6);

    return `
      <div class="rc__upsell">
        <div class="rc__upsell-glow no-empty"></div>
        <div class="rc__upsell-media">${media}</div>
        <div class="rc__upsell-body">
          ${u.tag ? `<div class="rc__upsell-tag">${this.ic('star', 14)} ${this.esc(u.tag)}</div>` : ''}
          ${title ? `<h3 class="rc__upsell-title">${title}</h3>` : ''}
          ${tplX ? `<p class="rc__upsell-text">${this.esc(tplX)}</p>` : ''}
          <div class="rc__upsell-product">
            ${p.vendor ? `<span class="rc__upsell-brand">${this.esc(p.vendor)}</span>` : ''}
            <span class="rc__upsell-pname">${this.esc(p.title)}</span>
            <span class="rc__upsell-price">${this.money(p.price)}</span>
            <span class="rc__upsell-diff">${this.ic('arrow', 14)} ${this.esc(diff)}</span>
          </div>
          ${chips.length ? `<div class="rc__upsell-specs">${chips.join('')}</div>` : ''}
        </div>
        <a class="rc__upsell-cta" href="${p.url}" target="_blank" rel="noopener">${this.esc(u.cta || 'Bekijk deze rollator')} ${this.ic('arrow', 18)}</a>
      </div>`;
  }
  upsellSpec(tpl, val) {
    const txt = (tpl || '%s').replace('%s', this.esc(val));
    return `<span class="rc__upsell-spec">${this.ic('dotcheck', 15, 2.4)} ${txt}</span>`;
  }

  /* ============ E-mail capture ============ */
  emailHtml() {
    const e = this.config.email || {};
    if (!e.enable) return '';
    if (this.sent) {
      const title = (e.successTitle || 'Gelukt, %s!').replace('%s', this.esc(this.sentName || ''));
      const text = (e.successText || '').replace('%s', `<strong>${this.esc(this.sentEmail || '')}</strong>`);
      return `
        <div class="rc__email">
          <div class="rc__sent">
            <div class="rc__sent-icon">${this.ic('check', 36, 2.4)}</div>
            <h3 class="rc__sent-title">${title}</h3>
            <p class="rc__sent-text">${text}</p>
            <button type="button" class="rc__restart" data-act="restart">${this.esc(e.restart || 'Opnieuw beginnen')}</button>
          </div>
        </div>`;
    }
    return `
      <div class="rc__email">
        <div class="rc__email-head">
          ${e.tag ? `<div class="rc__email-tag">${this.ic('mail', 18)} ${this.esc(e.tag)}</div>` : ''}
          <h3 class="rc__email-title">${this.esc(e.title)}</h3>
          ${e.text ? `<p class="rc__email-text">${this.esc(e.text)}</p>` : ''}
        </div>
        <div class="rc__email-form">
          <div class="rc__field">
            <label>${this.esc(e.nameLabel || 'Uw naam')}</label>
            <input class="rc__input" type="text" data-rc-name placeholder="${this.esc(e.namePlaceholder || '')}" value="${this.esc(this.name)}">
          </div>
          <div class="rc__field">
            <label>${this.esc(e.emailLabel || 'Uw e-mailadres')}</label>
            <input class="rc__input" type="email" data-rc-email placeholder="${this.esc(e.emailPlaceholder || '')}" value="${this.esc(this.email)}">
          </div>
          <button type="button" class="rc__email-send" data-act="send" disabled>${this.ic('mail', 19)} ${this.esc(e.send || 'Verstuur')}</button>
          ${e.fine ? `<p class="rc__email-fine">${this.esc(e.fine)}</p>` : ''}
        </div>
      </div>`;
  }
  emailValid() { return /.+@.+\..+/.test(this.email); }
  bindEmail() {
    const restart = this.els.results.querySelector('.rc__email [data-act="restart"]');
    if (restart) { restart.addEventListener('click', () => this.restart()); return; }
    const nameI = this.els.results.querySelector('[data-rc-name]');
    const emailI = this.els.results.querySelector('[data-rc-email]');
    const send = this.els.results.querySelector('[data-act="send"]');
    if (!send) return;
    const refresh = () => { send.disabled = !(this.name.trim() && this.emailValid()); };
    if (nameI) nameI.addEventListener('input', (e) => { this.name = e.target.value; refresh(); });
    if (emailI) emailI.addEventListener('input', (e) => { this.email = e.target.value; refresh(); });
    send.addEventListener('click', () => this.onSend());
    refresh(); // knop begint uitgeschakeld, de velden zijn altijd leeg
  }
  buildPayload() {
    // antwoorden in leesbare vorm (voor "keuzes" onderaan de mail)
    const answers = this.questions
      .map((q, i) => ({ q, i }))
      .filter((x) => this.isVisible(x.i))
      .map(({ q, i }) => {
        let value;
        if (q.type === 'slider') value = this.fmtSlider(q, this.answers[i]);
        else value = q.options[this.answers[i]] ? q.options[this.answers[i]].label : null;
        return { question: q.title, value };
      })
      // een zichtbare vraag zonder antwoord (alleen mogelijk via een
      // handmatig aangepaste ?rc=) hoort niet in de mail
      .filter((a) => a.value != null && a.value !== '');
    // de getoonde top-N producten
    const winners = this.lastWinners || this.rank();
    const products = winners.map((w) => ({
      id: w.product.id,
      title: w.product.title,
      vendor: w.product.vendor,
      url: window.location.origin + (w.product.url || ''),
      image: w.product.image,
      price: w.product.price,
      priceLabel: this.money(w.product.price),
      match: w.matchPct,
      maxweight: w.product.spec ? w.product.spec.maxweight : null,
      weight: w.product.spec ? w.product.spec.weight : null,
    }));
    return {
      name: this.name.trim(),
      email: this.email.trim(),
      answers,
      products,
      resultUrl: this.resultUrl(),
    };
  }
  onSend() {
    if (!this.name.trim() || !this.emailValid()) return;
    const endpoint = this.config.email && this.config.email.endpoint;
    if (endpoint) {
      try {
        fetch(endpoint, {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
          body: JSON.stringify(this.buildPayload()),
          mode: 'cors',
        }).then((r) => {
          if (!r.ok) console.warn('[rollator-keuzehulp] endpoint gaf status', r.status);
        }).catch((err) => console.warn('[rollator-keuzehulp] versturen mislukt', err));
      } catch (e) { console.warn('[rollator-keuzehulp] fetch-fout', e); }
    } else {
      console.warn('[rollator-keuzehulp] geen endpoint ingesteld (sectie-instelling "Backend-endpoint"); er wordt niets verstuurd.');
    }
    this.sent = true;
    this.sentName = this.name.trim().split(' ')[0];
    this.sentEmail = this.email.trim();
    this.renderResults();
    // Naar de e-mailsectie scrollen zodat de bovenkant (de succesmelding die
    // het formulier vervangt) netjes in beeld komt. Smooth via de globale
    // scroll-behavior in theme.css.
    const section = this.els.results.querySelector('.rc__email');
    if (section) section.scrollIntoView({ block: 'start' });
  }
}

customElements.define('rollator-keuzehulp', RollatorKeuzehulp);
